export var FILE_REFERENCE_LIMIT = 8;
